import { Link } from 'react-router-dom';
import Footer from '../home/components/Footer';

const LOGO_URL =
  'https://static.readdy.ai/image/9ce25d869b896a3f5b856271bcc15d01/04593552a0ea563d300a18e4891c8936.jpeg';

export default function Kasutustingimused() {
  return (
    <div className="min-h-screen bg-white flex flex-col font-sans">
      {/* Header */}
      <header className="bg-white border-b border-gray-100 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-8 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center h-12 w-auto">
            <img src={LOGO_URL} alt="IISRAL Recycling OÜ" className="h-12 w-auto object-contain" />
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-eco-green transition-colors cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-left-line" />
            </div>
            Tagasi avalehele
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-8 py-16">
          {/* Page title */}
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-6 h-0.5 bg-eco-green" />
              <span className="text-eco-green text-xs font-bold uppercase tracking-widest">Juriidiline teave</span>
            </div>
            <h1 className="text-4xl font-extrabold text-gray-900 mb-4">Kasutustingimused</h1>
            <p className="text-sm text-gray-400">Viimati uuendatud: 20. märts 2026</p>
          </div>

          <div className="prose prose-sm max-w-none space-y-10 text-gray-600 text-sm leading-relaxed">

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">1. Üldteave</h2>
              <p>
                Käesolevad kasutustingimused reguleerivad IISRAL Recycling OÜ (registrikood: 12345678,
                asukoht: Eesti) veebilehe <strong>iisral.eu</strong> kasutamist. Veebilehe kasutamisega
                nõustute käesolevate tingimustega täies mahus. Palume tingimused hoolikalt läbi lugeda.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">2. Teenuse kirjeldus</h2>
              <p>
                IISRAL Recycling OÜ pakub ehitusjäätmete sorteerimise, käitlemise, logistika ja koristustöödega
                seotud teavet ning kontaktvõimalusi. Veebileht on informatiivse iseloomuga ega paku otseseid
                tehinguid ega lepingute sõlmimist veebis.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">3. Intellektuaalomand</h2>
              <p>
                Kõik veebilehel avaldatud materjalid — sh tekstid, pildid, logod ja kujundus — on IISRAL
                Recycling OÜ intellektuaalomand või on kasutatud vastavate litsentsidega. Materjalide kopeerimise,
                levitamise või taasavaldamise eest ilma kirjaliku loata vastutate ise.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">4. Vastutuse piirang</h2>
              <p>
                IISRAL Recycling OÜ püüab hoida veebilehe sisu ajakohase ja täpse, kuid ei garanteeri
                veebilehe katkematut toimimist ega kogu teabe täielikkust. Ettevõte ei vastuta kahjude eest,
                mis tulenevad veebilehe kasutamisest või selle kättesaamatusest.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">5. Kolmandate osapoolte lingid</h2>
              <p>
                Veebileht võib sisaldada linke kolmandate osapoolte veebilehtedele. IISRAL Recycling OÜ ei
                vastuta nende sisu ega privaatsuspraktikate eest.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">6. Muudatused</h2>
              <p>
                Jätame endale õiguse kasutustingimusi igal ajal muuta. Oluliste muudatuste korral
                teavitame sellest veebilehel. Veebilehe edasine kasutamine pärast muudatusi tähendab
                uute tingimustega nõustumist.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">7. Kohaldatav õigus</h2>
              <p>
                Käesolevaid tingimusi reguleerib Eesti Vabariigi õigus. Kõik vaidlused lahendatakse
                Eesti kohtutes.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">8. Kontakt</h2>
              <p>
                Küsimuste ja ettepanekute korral võtke meiega ühendust:{' '}
                <a
                  href="mailto:recycling@iisral.eu"
                  className="text-eco-green hover:underline font-medium"
                >
                  recycling@iisral.eu
                </a>
              </p>
            </section>
          </div>

          {/* Back link */}
          <div className="mt-14 pt-8 border-t border-gray-100">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-eco-green text-white text-sm font-bold px-6 py-3 rounded-full cursor-pointer whitespace-nowrap hover:bg-dark-green transition-colors"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-left-line" />
              </div>
              Tagasi avalehele
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
